export default __webpack_public_path__ + "static/media/hercules-project.dac0f89f.PNG";